import "./ProductCatalog.module.css";
import Header from "@/reusable_sections/Header";
import Catalog from "./sections/Catalog";
import Inquiry from "./sections/Inquiry";
import Share from "./sections/Share";
import Footer from "@/reusable_sections/Footer";
export default function ProductCatalogPage() {
  return <div>
      <Header />
      <Catalog />
      <Inquiry />
      <Share />
      <Footer />
    </div>;
}